import { Radio, RadioGroup } from '@headlessui/react';
import { BILLING_FREQUENCIES, Frequency, Tier } from '../subscriptions.constants';
import classNames from 'classnames';
import { ThemeText, ThemeBackground, ThemePrimary } from '../../../context/theme/ThemeConstantsUpdated';

const { mainText } = ThemeText;
const { mainBackground } = ThemeBackground;
const { primaryBackground, primaryShadow } = ThemePrimary;

export const BillingToggle = (props: Props) => {
  const { tier, frequency, setFrequency } = props;

  return (
    <fieldset aria-label="Payment frequency">
      <RadioGroup
        value={frequency}
        onChange={setFrequency}
        className={classNames(
          mainText,
          mainBackground,
          primaryShadow,
          'grid grid-cols-2 gap-x-1 rounded-full p-1 text-center font-semibold leading-5 shadow-md'
        )}
      >
        {BILLING_FREQUENCIES.map((option) => (
          <Radio
            key={option.value}
            value={option}
            className={({ checked }) =>
              classNames(
                checked && primaryBackground,
                checked ? 'text-white' : mainText,
                'cursor-pointer rounded-full px-2.5 py-1'
              )
            }
          >
            {option.label} ({tier.price[option.value]})
          </Radio>
        ))}
      </RadioGroup>
    </fieldset>
  );
};

type Props = {
  tier: Tier;
  frequency: Frequency;
  setFrequency: (frequency: Frequency) => void;
};
